import { render, staticRenderFns } from "./AppBarI18n.vue?vue&type=template&id=12e67add&scoped=true"
import script from "./AppBarI18n.vue?vue&type=script&lang=js"
export * from "./AppBarI18n.vue?vue&type=script&lang=js"
import style0 from "./AppBarI18n.vue?vue&type=style&index=0&id=12e67add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e67add",
  null
  
)

export default component.exports